// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__29I7b _boxes_inset__1SXXk","select":"Select_select__1J_Ri Input_input__29I7b _boxes_inset__1SXXk"};